export enum AdvisorBlockId {
  Awards = 'awards',
  Location = 'location',
}
